<div class="alert alert-{{ color }}" [class.alert-dismissable]="dismissable">
  <div type="button" class="close" *ngIf="dismissable" (click)="dismiss()">
    <span>×</span>
  </div>

  <div class="row no-gutters">
    <div class="col-auto pe-3" *ngIf="hasIcon">
		<ng-content select="[icon]"></ng-content>
    </div>
    <div class="col">
      <h5 class="alert-heading" *ngIf="hasHeadline">
        <ng-content select="[headline]"></ng-content>
      </h5>
      <ng-content></ng-content>
    </div>
  </div>

</div>
